import React from "react";
import { Link } from "react-router-dom";

// Shared EGNS brand lockup — used in all page headers.
// Accepts size variants: sm (header), md (landing nav), lg (hero).
export default function Brand({ size = "sm", linkTo = "/dashboard", showText = true }) {
  const dims = {
    sm: { img: "w-9 h-9", title: "text-lg", sub: "text-[10px]" },
    md: { img: "w-11 h-11", title: "text-xl", sub: "text-[11px]" },
    lg: { img: "w-16 h-16", title: "text-2xl", sub: "text-[11px]" },
  }[size];

  const inner = (
    <div className="flex items-center gap-2.5 group" data-testid="brand-lockup">
      <div className={`${dims.img} rounded-xl overflow-hidden bg-white border border-border flex items-center justify-center shrink-0 shadow-sm`}>
        <img src="/brand/egns-logo.jpg" alt="EGNS — Egyptian German Nursing School" className="w-full h-full object-contain p-0.5" />
      </div>
      {showText && (
        <div className="leading-tight min-w-0">
          <div className={`font-display font-semibold tracking-tight text-foreground ${dims.title}`}>
            EGNS
          </div>
          <div className={`uppercase tracking-[0.18em] text-muted-foreground whitespace-nowrap ${dims.sub}`}>
            Nursing School
          </div>
        </div>
      )}
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} aria-label="EGNS — home" data-testid="brand-link">
        {inner}
      </Link>
    );
  }
  return inner;
}
